import React from 'react';
import { CookiesProvider as ReactCookieProvider, Cookies } from 'react-cookie';

const CookieProvider = ({ children, req }) => (
  <ReactCookieProvider
    cookies={!req ? undefined : new Cookies(req?.headers?.cookie)}
  >
    {children}
  </ReactCookieProvider>
);

export default CookieProvider;
